Object.defineProperty(exports,"__esModule",{value:true});exports.getSecurityDeviceHealthException=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};exports.default=




getStoreSecurityDeviceExceptionsById;var _types=require('./types');var exceptions=_interopRequireWildcard(_types);var _armStateData=require('../armState/armStateData');var _securityDeviceArmState=require('../armState/securityDeviceArmState');var _securityDeviceHealthStatus=require('../healthStatus/securityDeviceHealthStatus');function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function getStoreSecurityDeviceExceptionsById(session,storeId){
var store=session.Store.withId(storeId);
var securityDevices=store.securityDeviceIds.
toModelArray().
filter(function(device){return device.hasHealthExceptions();});

return securityDevices.map(function(device){
var status={};

var exception=getSecurityDeviceHealthException(device);
var exceptionKey=getExceptionKey(exception);
var armStateData=(0,_armStateData.armStateDataForDevice)(device);

if(device.hasSecurityExceptions()){
status.type=armStateData.armStateType;
status.typeDisplay=armStateData.armStateTitle;
}else{
status.type=_securityDeviceHealthStatus.HealthStatus.UNHEALTHY;
status.typeDisplay=exceptions.typeDisplay[exceptionKey];
}

status.action=armStateData.armStateAction;
status.actionDisplay=armStateData.armStateActionTitle;
status.label=exceptions.label[exceptionKey];

var healthState=getHealthState(device);
healthState.typeTitle=exceptions.typeDisplay[exceptionKey];

return _extends({},
device.ref,{
armState:(0,_securityDeviceArmState.getSecurityDeviceArmState)(device),
healthState:healthState,
status:status});

});
}

var getHealthState=function getHealthState(securityDevice){var

healthStatus=





securityDevice.healthStatus,healthStatusUpdatedAt=securityDevice.healthStatusUpdatedAt,translatedUnhealthyReason=securityDevice.translatedUnhealthyReason,translatedUnhealthyReasonAction=securityDevice.translatedUnhealthyReasonAction,unhealthyAt=securityDevice.unhealthyAt,securityStatusUpdatedAt=securityDevice.securityStatusUpdatedAt;

return(0,_securityDeviceHealthStatus.createHealthStatus)(
healthStatus,
translatedUnhealthyReason,
translatedUnhealthyReasonAction,
unhealthyAt||healthStatusUpdatedAt);

};

var getSecurityDeviceHealthException=exports.getSecurityDeviceHealthException=function getSecurityDeviceHealthException(securityDevice){return(
securityDevice.unhealthyReason);};

var getExceptionKey=function getExceptionKey(exception){return(
Object.keys(exceptions.types).find(
function(key){return exceptions.types[key]===exception;}));};